import React from 'react';
import { useSelector } from 'react-redux';
import { Grid } from 'semantic-ui-react';

// @ts-ignore
import EntityOptions from 'components/EntityOptions';
import { selectFertilizerSchemaInnerEntityTypeId } from 'services/schemas/selectors';
import { EntityId } from 'services/entities/types';
import { EntityDropdownOptions } from './types';
import { FertilizerEntityOptions } from './components/FertilizerSchemaInnerEntityOptions/types';
import FertilizerSchemaInnerEntityOptions from './components/FertilizerSchemaInnerEntityOptions';
import FertilizerSchemaInnerEntityTableFieldRender from './components/FertilizerSchemaInnerEntityTableFieldRender';
import FertilizerSchemaInnerEntityTableFieldWarning from './components/FertilizerSchemaInnerEntityTableFieldWarning';

export interface Props {
    name: string;
    validate?: any;
    entityId?: EntityId;
}

export default function FertilizerSchemaInnerEntityTableField(
    props: Props
): React.ReactElement | null {
    const { name, validate, entityId } = props;

    const fertilizerSchemaInnerEntityTypeId = useSelector(
        selectFertilizerSchemaInnerEntityTypeId
    );

    if (!fertilizerSchemaInnerEntityTypeId) {
        return null;
    }

    return (
        <EntityOptions
            entityTypeId={fertilizerSchemaInnerEntityTypeId}
            entityId={entityId}
        >
            {(options: EntityDropdownOptions): React.ReactElement => (
                <FertilizerSchemaInnerEntityOptions
                    options={options}
                    fertilizerEntityId={entityId}
                >
                    {(
                        innerEntityOptions: FertilizerEntityOptions
                    ): React.ReactElement => (
                        <Grid>
                            <Grid.Row>
                                <Grid.Column>
                                    <FertilizerSchemaInnerEntityTableFieldRender
                                        name={name}
                                        validate={validate}
                                        entityTypeId={
                                            fertilizerSchemaInnerEntityTypeId
                                        }
                                        entityId={entityId}
                                        options={innerEntityOptions}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <FertilizerSchemaInnerEntityTableFieldWarning
                                options={innerEntityOptions}
                            />
                        </Grid>
                    )}
                </FertilizerSchemaInnerEntityOptions>
            )}
        </EntityOptions>
    );
}
